import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { UserComponent } from './user.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LazyImageModule } from '@redoc-starter/redoc';

@NgModule({
    declarations: [
        UserComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,
        LazyImageModule
    ],
    exports: [
        UserComponent
    ]
})
export class UserModule {
}
